import React, { useEffect } from "react";
import $ from "jquery"

const sliderArray = [
    'thermatru_difference',
    'thermatru_new_products',
    'thermatru_key_success',
    'thermatru_tools_support',
    'fypon_advantage',
    'fypon_new_products',
    'tools_support_fypon',
    'prmedia'
]


const GuidedPath = React.memo(function GuidedPath({visible , setGuidedView , canvasSceneChange,currentCubempatArrayIndexName,handleupdateGuidedPathArrayIndex}) {


    const[slidearrayIndex , setSlideArrayIndex] = React.useState(null)
    
    useEffect(() => {

        $(".back_btns").css('color','#212529')

    },[])
    
    useEffect(() => {
        if(currentCubempatArrayIndexName !== "") {

            let x = sliderArray.findIndex((val) => {

                return val===currentCubempatArrayIndexName

            })
            setSlideArrayIndex(x)
            handleupdateGuidedPathArrayIndex("")
        }
    },[currentCubempatArrayIndexName])
    
    useEffect(() => {

        
        if(slidearrayIndex !== null){


            $(".back_btns").css('color','#e02f25')
            $(".next_btns").css('color','#e02f25')

            canvasSceneChange(sliderArray[slidearrayIndex])
            if(slidearrayIndex > 6) {

                $(".next_btns").css('color','#212529')

            }

            if(slidearrayIndex < 1) {

                $(".back_btns").css('color','#212529')

            }


            
        }
    },[slidearrayIndex])

    

    const prevScene = () => {

        if(slidearrayIndex > 0 ) {

            setSlideArrayIndex(slidearrayIndex-1)

        }
    }
    const nextScene = () =>{

        if(slidearrayIndex === null) {
                
            setSlideArrayIndex(0)

        }

        if(slidearrayIndex < 7) {
            setSlideArrayIndex(slidearrayIndex+1)
        }
        
        

    }
    return(

        <div className="bottons_div" style={visible ? { 'display' : 'block'} : {'display' : 'none' }}>
            <a href="#" className="btn back_btns" onClick={prevScene}>Back</a>
            <a href="#" className="btn next_btns" onClick={nextScene}>Next</a>
            <a href="#" className="btn exit_btns" onClick={() => {setSlideArrayIndex(0);setGuidedView("hide");}}>Exit</a>
        </div>

    )



});


export default GuidedPath;